/**
 * Model reprezentujący zbiór parametrów konfiguracyjnych kliniki,
 * wykorzystywany do automatycznego uzupełniania szablonów Regulaminu Świadczenia Usług.
 */
export class TermsOfAgreementsAnswer {

  /** Pełna nazwa placówki weterynaryjnej.
   */
  public clinicName: string;

  /** Dokładny adres siedziby kliniki.
   */
  public clinicAddress: string;

  /**
   * Data blokady zwrotu przedpłaty.
   */
  public prepaidLockDate: string;

  /**
   * Limit czasu na anulowanie rezerwacji.
   */
  public maxReservationCancellation: string;

  /**
   * Adres e-mail przeznaczony do przyjmowania zgłoszeń reklamacyjnych.
   */
  public complaintEmailAddress: string;

  /**
   * Czas na rozpatrzenie reklamacji (wyrażony w dniach).
   */
  public complaintConsiderationDays: number;

}
